export default __webpack_public_path__ + "static/media/spreeha.d9e972e6.jpg";